/**
 * The widget's artwork, hosted on the site's Cloudinary: each URL asks for the size it is
 * shown at (2x for retina) and lets Cloudinary pick the format (WebP/AVIF) — `e_trim`
 * drops a drawing's transparent margins, `c_crop` cuts the advisor out of a larger frame.
 */
const CL = 'https://res.cloudinary.com/laboratoire-calebasse/image/upload';

export const ART = {
  /** floating button, sm:+ — the resting advisor above the "Conseiller virtuel" pill (1144² frame) */
  fabRest: `${CL}/f_auto,q_auto,w_440/v1791464064/1_6074aea102.png`,
  /** on hover: the waving advisor over the "Bonjour, c'est Flo !" pill, the same frame as
   *  fabRest (pill at x 12.6–100%, y 80–100%); the source is 286px wide, so no w_ to upscale */
  fabHover: `${CL}/f_auto,q_auto/v1793203350/7854_c7f305fff5.png`,
  /** floating button, phones: the round chat button */
  fabPhone: `${CL}/v1791464053/_6663f46012.svg`,
  /** the greeting at the top of the chat: botanical background, the resting advisor without his pill */
  greetingBackground: (width: number) =>
    `${CL}/f_auto,q_auto,w_${width}/v1791464035/Fond_botanique_minimaliste_vert_pastel_d8a5836d40.png`,
  greetingAdvisor: `${CL}/c_crop,x_330,y_260,w_640,h_664/f_auto,q_auto,h_400/v1791464064/1_6074aea102.png`,
  /** the advisor climbing over the input while the user types: his head,
     down to the end of the headset mic (the edge hides the face from just below the nose) */
  peekHead: `${CL}/c_crop,x_94,y_46,w_1082,h_924/f_auto,q_auto,w_140/v1791468683/Image_Chat_GPT_8_oct_2026_16_07_35_Modifie_ca28c62b99.png`,
  /** his face, while an answer is on its way (before the three dots) */
  typingAvatar: `${CL}/e_trim/f_auto,q_auto,h_80/v1791475608/7742_d264f62043.png`,
  peekLeftHand: `${CL}/e_trim/f_auto,q_auto,w_80/v1791464607/_937110ab7d.png`,
  peekRightHand: `${CL}/e_trim/f_auto,q_auto,w_80/v1791464601/_d8ff7697db.png`,
};
